/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import {  } from "relay-runtime";
export type PdpRespSwatchSelector_item = {
    readonly isRingItem: boolean | null;
    readonly " $fragmentRefs": FragmentRefs<"SwatchSelector_item">;
    readonly " $refType": "PdpRespSwatchSelector_item";
};
export type PdpRespSwatchSelector_item$data = PdpRespSwatchSelector_item;
export type PdpRespSwatchSelector_item$key = {
    readonly " $data"?: PdpRespSwatchSelector_item$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespSwatchSelector_item">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSwatchSelector_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isRingItem",
      "storageKey": null
    },
    {
      "args": [
        {
          "kind": "Literal",
          "name": "shouldFetchBuyerInfo",
          "value": true
        }
      ],
      "kind": "FragmentSpread",
      "name": "SwatchSelector_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};
(node as any).hash = '5ff5ca83955f8a134ee9cf2073a72614';
export default node;
